module.exports = __webpack_public_path__ + "img/467.673c0668.png";